import React, { Fragment, useEffect, useState } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import "moment/dist/locale/ru";
import Grid from "../Grid/Grid.jsx";
import MonthPicker from "../MonthPicker/MonthPicker.jsx";
import QuotaEditor from "../QuotaEditor/QuotaEditor.jsx";
import {
    MATERIAL_UI_PROPS,
    monthNames,
    STATE_DATE_FORMAT,
    ALL_RATES,
} from "../../lib/data";
import { turnNumbertoObjkey } from "../../lib/helperFuncs.jsx";

import QuotaMassEditor from "../QuotaEditor/QuotaMassEditor.jsx";
import EditIcon from "@material-ui/icons/Edit";
import { Box, Button, Paper, Tab, Tabs, Typography } from "@material-ui/core";
import { green } from "@material-ui/core/colors";
import axios from "axios";

const styles = {
    overlay: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 100,
    },
    loader: {
        border: "16px solid #f3f3f3",
        borderTop: "16px solid #3498db",
        borderRadius: "50%",
        width: 120,
        height: 120,
        animation: "spin 2s linear infinite",
    },
    "@keyframes spin": {
        "0%": {
            transform: "rotate(0deg)",
        },
        "100%": {
            transform: "rotate(360deg)",
        },
    },
};

const GridQuotas = (props) => {
    const web = true;

    const [month, setMonth] = useState(moment());
    const date_start = month.format("YYYY-MM-01");
    const daysInMonth = month.daysInMonth();
    const date_end = month.format(`YYYY-MM-${daysInMonth}`);
    const [cells, setCells] = useState(
        createBooleanMatrix(props.auxData.length + 1, month.daysInMonth() + 1),
    );
    const [editFormVisible, setEditFormVisible] = useState(false);
    const [monthFormVisible, setMonthFormVisible] = useState(false);

    const [modalVisible, setModalVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [maySwitch, setMaySwitch] = useState(false);
    const [update, setUpdate] = useState(false);

    const closeModalForm = () => {
        setModalVisible(false);
    };
    const MAX_GRID_ROWS = 1000;

    const outerRates = props.rates && [ALL_RATES].concat(props.rates);
    const activeRates =
        outerRates &&
        outerRates.filter((rate) => rate.active && rate.own_quotas);
    const [pickedRate, setPickedRate] = useState(ALL_RATES);

    const actualRates = activeRates && returnActualRatesArr(activeRates, month);
    let pickedRateIdx = actualRates && actualRates.indexOf(pickedRate);
    const updateModalHandler = (e) => {
        setLoading(true);
        e.preventDefault();
        setModalVisible(false);

        let data = {};
        data.types = [];
        data.dates = [];
        data.rate_id = pickedRate.id;
        let onDates = false;

        for (let [k, v] of Object.entries(e.target)) {
            if (v.id === "closeQuota") {
                data.closeQuota = v.checked;
                continue;
            }

            if (v.id === "openQuota") {
                data.openQuota = v.checked;
                continue;
            }

            if (v.id == "dateMassStart" || v.id == "dateMassEnd") {
                onDates = true;
                continue;
            }

            if (v.id == "newQuota") {
                data.newQuota = v.value;
                continue;
            }

            if (v.localName == "input" && !onDates && v.checked) {
                data.types.push(v.id);
            } else if (v.localName == "input" && onDates && v.checked)
                data.dates.push(v.id);
        }

        axios
            .post(
                "/manager/data/hotels/" +
                    props.objectTemplate.hotel_id +
                    "/massEdit",
                {
                    data: data,
                },
            )
            .then(() => {
                setUpdate((prev) => !prev);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
                console.error(error);
            });
    };

    const [gridValues, setGridValues] = useState(
        createGridValues(
            month,
            props.auxData,
            props.items,
            props.objectTemplate,
            props.errorFields,
            pickedRate,
        ),
    );

    useEffect(() => {
        const rate_id = pickedRate.id;
        props.initAction({ date_start, date_end, web, rate_id });
        setCells(
            createBooleanMatrix(
                props.auxData.length + 1,
                month.daysInMonth() + 1,
            ),
        );
    }, [month, update, pickedRate]);

    useEffect(() => {
        setGridValues(
            createGridValues(
                month,
                props.auxData,
                props.items,
                props.objectTemplate,
                props.errorFields,
                pickedRate,
            ),
        );
    }, [props.items, pickedRate]);

    useEffect(() => {
        if (!props.errorFields) return undefined;
        setGridValues(
            updateGridWithResults(gridValues, props.errorFields.items),
        );
    }, [props.errorFields]);

    const handleSwitchReservations = () => {
        const searchEntity = "reservations";
        const searchParamObj = props.globalSearch.search[searchEntity];
        const updatedGrid = { ...gridValues };
        const itemsToUpdate = [];
        let isUpdated = false;
        cells.forEach((row, rowIndex) => {
            if (rowIndex === 0) return;
            row.forEach((col, colIndex) => {
                if (colIndex === 0) return;
                if (col) {
                    isUpdated = true;
                    const [gridRow, gridCol] = getGridIndexes(
                        rowIndex - 1,
                        colIndex,
                        updatedGrid,
                    );

                    const updatedItem = {
                        ...updatedGrid[gridRow][gridCol],
                    };

                    itemsToUpdate.push({ ...updatedItem });
                }
            });
        });
        if (isUpdated) {
            searchParamObj.room_type_id = `${itemsToUpdate[0].room_type_id}`;

            searchParamObj.date_in = `lteq:${itemsToUpdate[0].date}`;
            searchParamObj.date_out = `gt:${itemsToUpdate[parseInt(itemsToUpdate.length) - 1].date}`;
            searchParamObj.status = "except_cancelled";
            searchParamObj.page = 1;
            props.updateGlobalSearch(searchParamObj, searchEntity);
            setMaySwitch(true);
        }
    };

    useEffect(() => {
        if (maySwitch) {
            setMaySwitch(false);
            props.history.push({
                pathname: `/hotels/${props.objectTemplate.hotel_id}/reservations`,
            });
        }
    }, [maySwitch]);

    const closing = (close) => {
        setEditFormVisible(false);
        const updatedGrid = { ...gridValues };
        const itemsToUpdate = [];
        let isUpdated = false;
        cells.forEach((row, rowIndex) => {
            if (rowIndex === 0) return;
            row.forEach((col, colIndex) => {
                if (colIndex === 0) return;
                if (col) {
                    isUpdated = true;
                    const [gridRow, gridCol] = getGridIndexes(
                        rowIndex - 1,
                        colIndex,
                        updatedGrid,
                    );

                    let updatedItem = {
                        ...updatedGrid[gridRow][gridCol],
                        close: close,
                    };

                    updatedGrid[gridRow][gridCol] = { ...updatedItem };
                    itemsToUpdate.push({ ...updatedItem });
                }
            });
        });
        if (isUpdated) {
            setGridValues({ ...updatedGrid });
            setCells(
                createBooleanMatrix(
                    props.auxData.length + 1,
                    month.daysInMonth() + 1,
                ),
            );

            axios
                .post(
                    `/manager/data/hotels/${props.objectTemplate.hotel_id}/quotas_closing/${close}`,
                    {
                        itemsToUpdate,
                    },
                )
                .catch((error) => {
                    console.error(error);
                });
        }
    };

    const getAsuParameters = () => {
        const quotasAsuRoomTypeIds = [];
        const overbookingRoomTypeIds = [];

        props?.auxData?.forEach((e) => {
            if (e?.overbooking_in_asu) {
                overbookingRoomTypeIds.push(e.id);
            }

            if (e?.quotas_from_asu) {
                quotasAsuRoomTypeIds.push(e.id);
            }
        });

        const updatedGrid = { ...gridValues };

        let isUpdated = false;
        let isQuotaFromAsu = false;
        let isOverbooking = false;
        const roomTypeIds = [];

        cells.forEach((row, rowIndex) => {
            if (rowIndex === 0) return;
            row.forEach((col, colIndex) => {
                if (colIndex === 0) return;
                if (col) {
                    isUpdated = true;
                    const [gridRow, gridCol] = getGridIndexes(
                        rowIndex - 1,
                        colIndex,
                        updatedGrid,
                    );

                    let updatedItem = {
                        ...updatedGrid[gridRow][gridCol],
                    };

                    if (!roomTypeIds.includes(updatedItem.room_type_id)) {
                        roomTypeIds.push(updatedItem.room_type_id);
                    }

                    if (
                        quotasAsuRoomTypeIds.includes(updatedItem.room_type_id)
                    ) {
                        isQuotaFromAsu = true;
                    }

                    if (
                        overbookingRoomTypeIds.includes(
                            updatedItem.room_type_id,
                        )
                    ) {
                        isOverbooking = true;
                    }
                }
            });
        });

        // работать с овербукигом нужно чисто по строчкам категорий, множественный выбор категорий - только старый механизм
        if (isUpdated && roomTypeIds.length === 1) {
            return { isQuotaFromAsu, isOverbooking };
        } else {
            return false;
        }
    };

    const checkFreeUpgradeRoomTypes = () => {
        const freeUpgradeQuotasIds = [];

        props?.auxData?.forEach((e) => {
            if (e?.free_upgrade) {
                freeUpgradeQuotasIds.push(e.id);
            }
        });
        const updatedGrid = { ...gridValues };

        let countFreeUpgradeCells = 0;
        let cellCount = 0;

        cells.forEach((row, rowIndex) => {
            if (rowIndex === 0) return;
            row.forEach((col, colIndex) => {
                if (colIndex === 0) return;
                if (col) {
                    const [gridRow, gridCol] = getGridIndexes(
                        rowIndex - 1,
                        colIndex,
                        updatedGrid,
                    );

                    let updatedItem = {
                        ...updatedGrid[gridRow][gridCol],
                    };

                    if (
                      freeUpgradeQuotasIds.includes(updatedItem.room_type_id)
                    ) {
                        countFreeUpgradeCells++;
                    }

                    cellCount++;
                }
            });
        });

        return cellCount === countFreeUpgradeCells;
    };

    const updateHandler = (newValue) => {
        // updates data
        setEditFormVisible(false);

        let overbooking = null;
        if (newValue?.overbooking || newValue?.overbooking === 0) {
            overbooking = newValue.overbooking;
            newValue = null;
        }
        const updatedGrid = { ...gridValues };
        const itemsToUpdate = [];
        let isUpdated = false;
        cells.forEach((row, rowIndex) => {
            if (rowIndex === 0) return;
            row.forEach((col, colIndex) => {
                if (colIndex === 0) return;
                if (col) {
                    isUpdated = true;
                    const [gridRow, gridCol] = getGridIndexes(
                        rowIndex - 1,
                        colIndex,
                        updatedGrid,
                    );

                    const updatedItem = {
                        ...updatedGrid[gridRow][gridCol],
                        amount:
                            newValue ||
                            updatedGrid[gridRow][gridCol].amount ||
                            0,
                        rate_id: pickedRate.id,
                        free_upgrade_amount: null,
                        overbooking,
                    };

                    // updatedGrid[gridRow][gridCol] = { ...updatedItem };
                    itemsToUpdate.push({ ...updatedItem });
                }
            });
        });
        if (isUpdated) {
            // setGridValues({ ...updatedGrid });

            setCells(
                createBooleanMatrix(
                    props.auxData.length + 1,
                    month.daysInMonth() + 1,
                ),
            );
            props.submitAction(itemsToUpdate).then(() => {
                setUpdate((prev) => !prev);
            });
        }
    };
    
    const handleFreeUpgradeCount = (newFreeUpgradeCount) => {
        setEditFormVisible(false);

        const updatedGrid = { ...gridValues };
        const itemsToUpdate = [];
        let isUpdated = false;
        cells.forEach((row, rowIndex) => {
            if (rowIndex === 0) return;
            row.forEach((col, colIndex) => {
                if (colIndex === 0) return;
                if (col) {
                    isUpdated = true;
                    const [gridRow, gridCol] = getGridIndexes(
                      rowIndex - 1,
                      colIndex,
                      updatedGrid,
                    );

                    const updatedItem = {
                        ...updatedGrid[gridRow][gridCol],
                        free_upgrade_amount: newFreeUpgradeCount,
                    };

                    // updatedGrid[gridRow][gridCol] = { ...updatedItem };
                    itemsToUpdate.push({ ...updatedItem });
                }
            });
        });
        if (isUpdated) {
            // setGridValues({ ...updatedGrid });

            setCells(
              createBooleanMatrix(
                props.auxData.length + 1,
                month.daysInMonth() + 1,
              ),
            );
            props.submitAction(itemsToUpdate).then(() => {
                setUpdate((prev) => !prev);
            });
        }

    }

    const quotasEditHandler = (cells) => {
        setCells(cells);
        setEditFormVisible(true);
    };

    const handleMonthForm = (monthYear) => {
        let pickedMonthIndex = monthYear === -1 ? 11 : monthYear;

        if (monthYear && isNaN(monthYear)) {
            const monthName = monthYear.split(" ")[0];
            pickedMonthIndex = monthNames.indexOf(monthName);
        }

        const curMonth = moment();
        setMonthFormVisible(false);
        if (pickedMonthIndex > -1) {
            const pickedMonth = moment().month(pickedMonthIndex);
            if (curMonth > pickedMonth) {
                pickedMonth.add(1, "year");
                setMonth(pickedMonth);
            } else if (month.isSame(pickedMonth, "month")) {
                setMonthFormVisible(false);
            } else {
                setMonth(pickedMonth);
            }
        }
    };

    const closeEditForm = () => {
        setEditFormVisible(false);
        setCells(
            createBooleanMatrix(
                props.auxData.length + 1,
                month.daysInMonth() + 1,
            ),
        );
    };

    const ratesNames =
        actualRates &&
        actualRates.length > 0 &&
        actualRates.map((rate) => (
            <Tab
                title={rate.code !== rate.name ? rate.name : ""}
                label={rate.code || rate.name}
                key={`${rate.id}/${rate.code}`}
                onClick={() => {
                    // setMaxGridRows(MAX_GRID_ROWS);
                    setPickedRate(rate);
                }}
            />
        ));

    const rates = !ratesNames ? (
        <Box p={2}>
            <Typography>Нет доступных тарифов</Typography>
        </Box>
    ) : (
        <Tabs
            value={pickedRateIdx === -1 ? 0 : pickedRateIdx}
            indicatorColor={MATERIAL_UI_PROPS.colors.primary}
            textColor={MATERIAL_UI_PROPS.colors.primary}
            variant="scrollable"
            scrollButtons="true"
        >
            {ratesNames}
        </Tabs>
    );

    return (
        <Fragment>
            {props.loading ||
                (loading && (
                    <div style={styles.overlay}>
                        <div style={styles.loader}></div>
                    </div>
                ))}
            {monthFormVisible && (
                <MonthPicker
                    onClose={handleMonthForm}
                    open={monthFormVisible}
                    thirteenMonthNotVisible
                />
            )}

            <Button
                onClick={() => setModalVisible(true)}
                color="primary"
                variant="contained"
                endIcon={<EditIcon />}
                style={{ backgroundColor: green[500], marginBottom: "40px" }}
            >
                Массовое редактирование квот доступных номеров
            </Button>
            <Paper style={{ marginBottom: "30px" }} elevation={3}>
                {rates}
            </Paper>
            <Grid
                key={update}
                auxData={props.auxData}
                gridValues={gridValues}
                onSelect={quotasEditHandler}
                onMonthSelect={() => setMonthFormVisible(true)}
                onMonthChange={handleMonthForm}
                month={month}
                cells={cells}
                openLeftMenu={props.openLeftMenu}
            />

            {modalVisible && (
                <QuotaMassEditor
                    roomTypes={props.auxData}
                    isVisible={modalVisible}
                    onClose={closeModalForm}
                    onSubmit={updateModalHandler}
                    dateStart={date_start}
                    dateEnd={date_end}
                />
            )}

            {editFormVisible && (
                <QuotaEditor
                    isVisible={editFormVisible}
                    onClose={closeEditForm}
                    onSubmit={updateHandler}
                    handleFreeUpgradeCount={handleFreeUpgradeCount}
                    handleSwitchReservations={handleSwitchReservations}
                    closing={closing}
                    getAsuParameters={getAsuParameters}
                    checkFreeUpgradeRoomTypes={checkFreeUpgradeRoomTypes}
                />
            )}
        </Fragment>
    );
};

// Helper functions

/**
 * Creates empty grid values
 *
 * @param {Moment} curMoment
 * @param {array} roomTypes
 * @param {array} quotas
 * @param {object} objectTemplate

 *
 * @param errorFields
 * @param rate
 * @returns {object}
 */

const createGridValues = (
    curMoment,
    roomTypes,
    quotas,
    objectTemplate,
    errorFields = null,
    rate,
) => {
    const grid = {};
    const daysInMonth = curMoment.daysInMonth();
    roomTypes.forEach((roomType) => {
        const idStr = turnNumbertoObjkey(roomType.id);
        grid[idStr] = {};
        for (let i = 1; i <= daysInMonth; i++) {
            const day_DD = `${i}`.padStart(2, "0");

            grid[idStr][i] = {
                ...objectTemplate,
                amount: null,
                date: curMoment.format(`YYYY-MM-${day_DD}`),
                room_type_id: parseInt(roomType.id),
                close: false,
            };
        }
    });

    quotas.forEach((quota) => {
        const { room_type_id } = { ...quota };
        const { rate_id } = { ...quota };
        const date = +moment(quota.date).format("D");
        if (
            (rate.id === 99999999 && !rate_id) ||
            (rate.id !== 99999999 && rate_id === rate.id && rate.own_quotas)
        ) {
            grid[turnNumbertoObjkey(room_type_id)][date] = {
                ...quota,
            };
        }
    });

    return grid;
};

/**
 *
 * Returns indexes in gridValues based on selection array
 *
 * @param {int} rows
 * @param {int} cols
 * @param {object} gridValues
 *
 */

const getGridIndexes = (rowIndex, colIndex, gridValues) => {
    const gridRow = Object.keys(gridValues)[rowIndex];
    return [gridRow, colIndex];
};

/**
 *
 *  Creates boolean values matrix to support Grid comp-t operation
 *
 * @param {int} rows
 * @param {int} cols
 *
 **/

const createBooleanMatrix = (rows, cols) => {
    const matrix = [];
    for (let i = 0; i < rows; i++) {
        let row = [];
        for (let j = 0; j < cols; j++) {
            row.push(false);
        }
        matrix.push(row);
    }
    return matrix;
};

/**
 *
 * Appends cell update results to gridValues cells
 *
 * @param {*} gridValues
 * @param {*} results
 * @param {object} gridValues
 *
 */
const updateGridWithResults = (gridValues, results) => {
    const updatedGrid = { ...gridValues };
    Object.entries(results).forEach((entry) => {
        const [roomTypeId, roomTypeResults] = [...entry];
        const roomTypeIdkey = turnNumbertoObjkey(roomTypeId);
        Object.keys(updatedGrid[roomTypeIdkey]).forEach((key) => {
            const gridCell = updatedGrid[roomTypeIdkey][key];
            const date = gridCell.date;
            if (roomTypeResults[date]) {
                gridCell.result = { ...roomTypeResults[date] };
            }
        });
    });

    return updatedGrid;
};

/**
 * Return array of rates that are active in given dates
 *
 * @param {Array} rates
 * @param {moment} curMonth
 */

const returnActualRatesArr = (rates, curMonth) => {
    const curDate = moment().format(STATE_DATE_FORMAT);
    return rates.filter((rate) => {
        const rateMomentEndDate = moment(rate.date_end, STATE_DATE_FORMAT);
        if (
            rateMomentEndDate >= curMonth ||
            rateMomentEndDate.isBetween(
                curMonth.startOf("month").format(STATE_DATE_FORMAT),
                curMonth.endOf("month").format(STATE_DATE_FORMAT),
                undefined,
                "[]",
            )
        )
            return true;
    });
};

GridQuotas.propTypes = {
    objectTemplate: PropTypes.object,
    auxData: PropTypes.array,
    initAction: PropTypes.func,
    items: PropTypes.array,
    submitAction: PropTypes.func,
    errorFields: PropTypes.object,
    rate: PropTypes.object,
    updateAction: PropTypes.func,
};

export default GridQuotas;
